/** Currency symbols offered in the editor. "$" is the default. */
export const CURRENCY_SYMBOLS = ['$', '€', '£', '¥', '₹', '₩', 'C$', 'A$', 'R$', '₽'] as const

export function isKnownCurrencySymbol(value: unknown): value is string {
  return typeof value === 'string' && (CURRENCY_SYMBOLS as readonly string[]).includes(value)
}
